import React from 'react';
import { AuthContextProvider } from './AuthContext';
import { defaultColorPalette } from '../Theme';
import { typography } from '../Theme';
import { CookiesProvider } from 'react-cookie';
import { AppThemeProvider } from '../lib/components/AppThemeProvider';

const AppContextProviders = ({ children }) => {
  return (
    <AppThemeProvider
      colorPalette={defaultColorPalette}
      typography={typography}
    >
      <CookiesProvider>
        <AuthContextProvider>{children}</AuthContextProvider>
      </CookiesProvider>
    </AppThemeProvider>
  );
};

export default AppContextProviders;

export { SettingsContextProvider } from './SettingsContext';
